module.exports = __webpack_public_path__ + "media/dingdong2.fcaf7f5a.wav";